import * as React from "react";
const SvgB2BOriginIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 5.5, cy: 5.5, r: 4.25, stroke: "#D8D8D8", strokeWidth: 2.5 }));
export default SvgB2BOriginIcon;
